import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex align-center px-2 py-3" }
const _hoisted_2 = { class: "sidebar-footer" }
const _hoisted_3 = { class: "px-2 py-3 d-flex justify-end" }

import { computed, PropType, ref, watch } from 'vue';
    import { useRouter } from 'vue-router';
    import { useStore } from 'vuex';
    import SidebarItem, { type SidebarItem as SidebarItemInterface } from './SidebarItem.vue';
    import AQIcon from '@/components/shared/interactions/AQIcon.vue';

    type NavigationDrawerLocation = 'end' | 'start' | 'left' | 'top' | 'bottom' | 'right';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'BaseSidebar',
  props: {
        modelValue: Boolean,
        items: {
            type: Array as PropType<SidebarItemInterface[]>,
        },
        temporary: Boolean,
        location: String as PropType<NavigationDrawerLocation>,
        app: Boolean,
        rail: {
            type: Boolean,
            default: false,
        },
        expandOnHover: {
            type: Boolean,
            default: false,
        },
    },
  emits: ["update:modelValue", "item-click"],
  setup(__props, { emit: __emit }) {

    const router = useRouter();

    const props = __props;
    // Track the current active item's subitems if available
    const activeSubItems = ref<SidebarItemInterface[]>([]);

    // Computed property to return either the main items or subitems of the active item
    const sidebarItems = computed(() => {
        if (activeSubItems.value.length > 0) {
            return activeSubItems.value;
        }
        return props.items || [];
    });

    // Watch the route to update active subitems
    watch(
        () => router?.currentRoute?.value?.path || '',
        (newPath: string) => {
            // Skip if no path is available (e.g., in tests)
            if (!newPath) return;

            // Reset to main items when navigating away
            const currentItems = props.items || [];
            const matchingItem = findMatchingItem(currentItems, newPath);

            // If we find a matching item with subitems, use those
            if (matchingItem && matchingItem.subItems?.length) {
                activeSubItems.value = matchingItem.subItems;
                return;
            }

            // Check if we're in a nested route structure
            for (const item of currentItems) {
                if (item.subItems?.length) {
                    // Check if any of the subitems match the current path
                    const matchingSubItem = findMatchingItem(item.subItems, newPath);
                    if (matchingSubItem) {
                        // If we're in a nested route, show all subitems of the parent
                        activeSubItems.value = item.subItems;
                        return;
                    }
                }
            }

            // If no matches found, reset to empty
            activeSubItems.value = [];
        },
        { immediate: true },
    );

    // Helper function to find a matching item based on path
    function findMatchingItem(
        items: SidebarItemInterface[],
        path: string,
    ): SidebarItemInterface | null {
        for (const item of items) {
            if (item.path && path.startsWith(item.path)) {
                return item;
            }
            // Check if any of the subitems match the path
            if (item.subItems?.length) {
                const matchingSubItem = findMatchingItem(item.subItems, path);
                if (matchingSubItem) {
                    return item; // Return the parent item that has the matching subitem
                }
            }
        }
        return null;
    }

    const emit = __emit;

    const internalDrawer = computed({
        get: () => props.modelValue,
        set: (val) => emit('update:modelValue', val),
    });

    const handleSidebarItemClick = () => {
        emit('item-click');
    };

    const chevronIcon = computed(() => (props.rail ? 'mdi-chevron-right' : 'mdi-chevron-left'));

    const store = useStore();
    const handleToggle = () => {
        store.dispatch('navigation/toggleSidebarBehavior');
    };

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_AQButton = _resolveComponent("AQButton")!
  const _component_v_navigation_drawer = _resolveComponent("v-navigation-drawer")!

  return (_openBlock(), _createBlock(_component_v_navigation_drawer, {
    modelValue: internalDrawer.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((internalDrawer).value = $event)),
    rail: props.rail,
    "expand-on-hover": props.expandOnHover,
    temporary: __props.temporary,
    location: __props.location,
    app: __props.app
  }, {
    append: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_divider),
        _createElementVNode("div", _hoisted_3, [
          (!props.temporary)
            ? (_openBlock(), _createBlock(_component_AQButton, {
                key: 0,
                size: "small",
                variant: "text",
                color: "white",
                class: _normalizeClass([{ 'rotate-180': props.rail }, "toggle-btn"]),
                onClick: handleToggle
              }, {
                default: _withCtx(() => [
                  _createVNode(AQIcon, { name: chevronIcon.value }, null, 8, ["name"])
                ]),
                _: 1
              }, 8, ["class"]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!props.rail)
          ? (_openBlock(), _createBlock(_component_v_img, {
              key: 0,
              src: require('@/public/assets/images/aquassist_reverse.svg'),
              alt: "Aquassist Logo",
              "min-height": "50",
              "max-height": "50",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push('/clients')))
            }, null, 8, ["src"]))
          : (_openBlock(), _createBlock(_component_v_img, {
              key: 1,
              src: require('@/public/assets/images/aquassist-icon.svg'),
              alt: "Aquassist Icon",
              "min-height": "30",
              "max-height": "30",
              class: "mx-auto"
            }, null, 8, ["src"]))
      ]),
      _createVNode(_component_v_divider, { color: "white" }),
      _createVNode(_component_v_list, {
        density: "compact",
        nav: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sidebarItems.value, (item, idx) => {
            return (_openBlock(), _createBlock(SidebarItem, {
              key: item.value || idx,
              item: item,
              "is-railed": props.rail,
              onItemClick: handleSidebarItemClick
            }, null, 8, ["item", "is-railed"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "rail", "expand-on-hover", "temporary", "location", "app"]))
}
}

})